import InfusionClinicAdmin from "./InfusionClinicAdmin";
export default InfusionClinicAdmin;
